import React from 'react';
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';

import ReportView from './components/ReportView/ReportView';

const BeyondBillingReports = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const reportId = searchParams.get('reportId');

  if (reportId) {
    return <ReportView />;
  }

  if (location.pathname.endsWith('/reports')) {
    return <Navigate to="standard" replace />;
  }

  return <Outlet />;
};

export default BeyondBillingReports;
